import ReactDOM from 'react-dom'

import { ChartLayout, Quote } from '../charts-lib'
import { SpecificChartFunctionality, getCustomColorsFromCookies } from '../shared/chartLayoutConfig'
import { parseJSONFromScript } from '../shared/parseJSONFromScript'
import { ready } from '../shared/ready'
import { getData } from './indices-data'
import type { Indices } from './indices-data'
import './market_sentiment'
import './refresh'

function getChartConfig(ticker: string) {
  return {
    layout: '1h1v',
    width: 320,
    height: 190,
    barWidth: 3,
    barMargin: 1,
    scrollable: false,
    editable: false,
    cross: false,
    colors: getCustomColorsFromCookies(),
    specificChartFunctionality: SpecificChartFunctionality.smallIndex,
    theme: document.documentElement.classList.contains('dark') ? 'dark' : 'light',
    charts: [
      {
        height: 190,
        timeframe: 'i10',
        scale: 'linear',
        ticker: ticker,
        // leftOffset: 0,
        instrument: 'stock',
        refreshData: false,
        // stretch: true,
        panes: [
          {
            height: 190,
            elements: [
              {
                type: 'charts/candle_stick',
                overlays: [],
              },
            ],
          },
        ],
      },
    ],
  }
}

function renderChart({ ticker, element }: { ticker: string; element: HTMLElement | null }) {
  if (element) {
    ReactDOM.render(
      <div className="chart-layout-wrapper">
        <ChartLayout config={getChartConfig(ticker)} />
      </div>,
      element
    )
  }
}

ready(function () {
  const indices = parseJSONFromScript<Indices>('js-indices')!

  Quote.create(getData('^DJI', 'DOW', indices)).save()
  Quote.create(getData('^IXIC', 'NASDAQ', indices)).save()
  Quote.create(getData('^GSPC', 'S&P 500', indices)).save()
  Quote.create(getData('^RUT', 'RUSSELL 2000', indices)).save()

  renderChart({ ticker: 'DOW', element: document.getElementById('dow') })
  renderChart({ ticker: 'NASDAQ', element: document.getElementById('nasdaq') })
  renderChart({ ticker: 'S&P 500', element: document.getElementById('sp500') })
  renderChart({ ticker: 'RUSSELL 2000', element: document.getElementById('rut') })
})
